import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';

const FolderAllocateResponsibleFilters = ({ t, filters, onChangeFilterValue, loadStates }) => {
  const handleTextFilterChanged = name => event => {
    onChangeFilterValue(name, event);
  };

  const handleCheckBoxFilterChanged = name => event => {
    onChangeFilterValue(name, event.target.checked);
  };

  const handleStateChanged = name => value => {
    onChangeFilterValue(name, value || null);
  };

  return (
    <Grid item container xs={12} spacing={2}>
      <Grid item xs={12} sm={6} lg={3}>
        <TextField
          id={'folderAllocateResponsible_filters_folderNumber'}
          fullWidth
          label={t('FolderAllocateResponsible.FolderNumber')}
          value={filters.folderNumber}
          onChange={handleTextFilterChanged('folderNumber')}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <TextField
          id={'folderAllocateResponsible_filters_client'}
          fullWidth
          label={t('FolderAllocateResponsible.Client')}
          value={filters.clientName}
          onChange={handleTextFilterChanged('clientName')}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <Autocomplete
          id={'folderAllocateResponsible_filters_status'}
          fullWidth
          value={filters.stateId}
          onChange={handleStateChanged('stateId')}
          label={t('FolderAllocateResponsible.Status')}
          valueKey='stateId'
          labelKey='name'
          loadOptions={loadStates}
          isClearable
          isSearchable
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={3} pt={2}>
        <FormControlLabel
          control={
            <Checkbox
              id={'folderAllocateResponsible_filters_isAssignedResponsible'}
              checked={filters.isAssigned}
              onChange={handleCheckBoxFilterChanged('isAssignedResponsible')}
              color='primary'
              name='isAssignedResponsible'
            />
          }
          label={t('FolderAllocateResponsible.IsAssignedResponsible')}
        />
      </Grid>
    </Grid>
  );
};

FolderAllocateResponsibleFilters.propTypes = {
  t: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired,
  loadStates: PropTypes.func.isRequired
};

export default withTranslation()(FolderAllocateResponsibleFilters);
